import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['input', 'display']
  static classes = ['info', 'warning', 'error']

  connect() {
    this.inputTarget.addEventListener('input', this.onInput.bind(this))
    this.onInput()
  }
  
  disconnect() {
    this.inputTarget.removeEventListener('input', this.onInput.bind(this))
  }

  get maxLength() {
    return this.inputTarget.maxLength;
  }

  get remaining() {
    return this.maxLength - this.inputTarget.value.length
  }

  onInput = (evt) => {
    this.displayTarget.innerText = this.remaining
    this.displayTarget.classList.remove('font-bold', ...[this.infoClass, this.warningClass, this.errorClass])
    this.displayTarget.classList.add(...this.stateClasses)
  }

  get state() {
    if (this.remaining > 150) {
      return 'info'
    } else if(this.remaining > 20) {
      return 'warning'
    } else {
      return 'error'
    }
  }

  get stateClasses() {
    const c = []
    switch (this.state) {
      case 'info':
        c.push(this.infoClass)
        break
      case 'warning':
        c.push(this.warningClass)
        c.push('font-bold')
        break
      case 'error':
        c.push(this.errorClass)
        c.push('font-bold')
        break
    }

    return c
  }
}
